<template>
    <div class="py-6 px-1 md:px-2 lg:px-6">
        <div class="mx-auto py-8 max-w-sm flex justify-center">
            <img src="/static/company/logo" style="margin: 8px; height: 125px" />
        </div>

        <slot />
    </div>
</template>

<script>
export default {
    name: 'Auth',
}
</script>
